<template>
    <div>
        <v-tabs background-color="white" v-model="syncedTab">
            <v-tabs-slider color="#363E59"></v-tabs-slider>
            <v-tab v-for="(item, i) in items" :key="i">
                {{ item.tab }}
            </v-tab>
        </v-tabs>
        <v-tabs-items v-model="syncedTab">
            <v-tab-item v-for="(item, i) in items" :key="i">
                <component v-bind:is="item.content"></component>
            </v-tab-item>
        </v-tabs-items>
    </div>
</template>
<script>
import ContractsDebt from '@/components/debts-info/contractsDebt/ContractsDebt.vue';
import AccountsDebt from '@/components/debts-info/accountsDebt/AccountsDebt.vue';
import ContractsNotices from '@/components/pre-trial-notices/contractsNotices/ContractsNotices.vue';
import AccountsNotices from '@/components/pre-trial-notices/accountsNotices/AccountsNotices.vue';
import ContractsActs from '@/components/acts/contractsActs/contractsActs.vue';
import AccountsActs from '@/components/acts/accountsActs/accountsActs.vue';

export default {
    name: 'TabsSliderContainer',
    components: { ContractsDebt, AccountsDebt, ContractsNotices, AccountsNotices, AccountsActs, ContractsActs },
    props: {
        items: {
            required: true
        },
        tab: {
            required: true
        }
    },
    computed: {
        syncedTab: {
            get() {
                return this.tab;
            },
            set(val) {
                this.$emit('update:tab', val);
            }
        }
    }
};
</script>

<style scoped lang="scss">
.v-tabs {
    .v-tab {
        text-transform: unset;
        letter-spacing: unset;
        font-size: 16px;
        white-space: unset;
        color: #363e59;
    }
}
.theme--light.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active),
.theme--light.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active) > .v-icon,
.theme--light.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active) > .v-btn,
.theme--light.v-tabs > .v-tabs-bar .v-tab--disabled {
    color: #6b7bb2;
}
</style>
